module.exports = __webpack_public_path__ + "static/media/share-ico.0c37663a.svg";